import { Injectable, OnDestroy } from '@angular/core'
import { CmsService, Occ } from '@spartacus/core'
import { MbDocumentService } from '../mb-document-service/mb-document.service'
import { Subscription } from 'rxjs'
import { PageTypeClasses } from '../../components/types'
import { BackgroundColors, backgroundColors } from '../../tailwind/configs/background-colors'
import { MbColor } from '../../tailwind/enums/color-enum'
import { filter } from 'rxjs/operators'
import CMSPage = Occ.CMSPage

@Injectable({
  providedIn: 'root'
})
export class CmsPageTypeService implements OnDestroy {

  readonly pageTypeClasses: PageTypeClasses = {
    applicationpage: 'application-page',
    categorypage: 'category',
    landingpage2template: 'homepage',
    instrumentpage: 'pdp-page',
    miltenyiuniversity: 'university-page',
    applicationprotocolspage: 'app-detail-page',
    productdetailspagetemplate: 'cmsPDP',
    jobdetailpage: 'jobs',
    pouploadtemplate: 'po-upload-page'
  }

  private subscription = new Subscription()

  constructor (private cmsService: CmsService,
               private documentService: MbDocumentService) {
  }

  init (): void {
    this.subscription.add(this.cmsService.getCurrentPage().pipe(
        filter(page => !!page)
    ).subscribe(page => {
      this.addBodyClass(page)
    }))
  }

  ngOnDestroy (): void {
    this.subscription.unsubscribe()
  }

  private addBodyClass (page: CMSPage): void {
    [...Object.keys(this.pageTypeClasses)].forEach(key => {
      this.documentService.querySelector('body')?.classList.remove((this.pageTypeClasses as any)[key])
    })
    const pageType = page?.properties?.formData?.pt_page_type?.value ?? ''
    const pageTypeClasses = this.pageTypeClasses[pageType]
    const backgroundColorClass= backgroundColors[page?.properties?.formData?.pt_pageBackgroundColor?.value?.identifier as BackgroundColors]
                                ?? (pageType === 'applicationpage' ? backgroundColors[MbColor.white] : backgroundColors[MbColor.grey])
    const bodyElement = this.documentService.querySelector('body')
    const mainElement = this.documentService.querySelector('main')
    const footerElement = this.documentService.querySelector('footer')
    if (!!pageTypeClasses) {
      bodyElement?.classList?.add(pageTypeClasses)
    }
    if (!!backgroundColorClass) {
      bodyElement?.classList?.add(backgroundColorClass)
      mainElement?.classList?.add(backgroundColorClass)
      footerElement?.classList.add(backgroundColorClass)
    }
  }
}
